import React, { useCallback, useEffect } from "react";
import { defaultLinkStyle } from "./link";

const clampOptions = {
    2: "line-clamp-2",
    3: "line-clamp-3",
} as const;

interface ClampedTextProps {
    lines: keyof typeof clampOptions;
    children: React.ReactNode;
}

export const ClampedText: React.FC<ClampedTextProps> = props => {
    const { lines, children } = props;
    const [isShowAllToggled, setIsShowAllToggled] = React.useState(false);
    const [hasTextOverflowed, setHasTextOverflowed] = React.useState(false);
    const textRef = React.useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!textRef.current) {
            return;
        }
        if (textRef.current.scrollHeight > textRef.current.clientHeight) {
            setHasTextOverflowed(true);
        }
    }, [textRef.current]); // eslint-disable-line react-hooks/exhaustive-deps
    const toggle = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        setIsShowAllToggled(t => !t);
    }, []);
    return (
        <div>
            <div ref={textRef} className={isShowAllToggled ? "" : clampOptions[lines]}>
                {children}
            </div>
            {hasTextOverflowed ? (
                <button onClick={toggle} className={`${defaultLinkStyle} text-[inherit]`}>
                    {isShowAllToggled ? "Show less" : "Show more"}
                </button>
            ) : null}
        </div>
    );
};
